<template>
    <div class="px-1">
        <div v-if="tracker.editing">
            <template v-if="tracker.type === 'duration'">
                <intensity
                    v-for="i in 2"
                    :key="`${tracker.type}-${i - 1}`"
                    :iconset="i - 1"
                    :selected-iconset="getSelectedIconset(tracker)"
                    @select-iconset="changeIconset(i)"
                ></intensity>
            </template>
            <template v-else="">
                <prompt
                    v-for="i in 4"
                    :key="`${tracker.type}-${i - 1}`"
                    :iconset="i - 1"
                    :selected-iconset="getSelectedIconset(tracker)"
                    @select-iconset="changeIconset(i)"
                ></prompt>
                <prompt
                    :key="`${tracker.type}-${7}`"
                    :iconset="7"
                    :selected-iconset="getSelectedIconset(tracker)"
                    @select-iconset="changeIconset(8)"
                ></prompt>
                <prompt
                    :key="`${tracker.type}-${8}`"
                    :iconset="8"
                    :selected-iconset="getSelectedIconset(tracker)"
                    @select-iconset="changeIconset(9)"
                ></prompt>
                <prompt
                    :key="`${tracker.type}-${9}`"
                    :iconset="9"
                    :selected-iconset="getSelectedIconset(tracker)"
                    @select-iconset="changeIconset(10)"
                ></prompt>
                <prompt
                    :key="`${tracker.type}-${4}`"
                    :iconset="4"
                    :selected-iconset="getSelectedIconset(tracker)"
                    @select-iconset="changeIconset(5)"
                ></prompt>
            </template>

            <transition name="simple-fade">
                <small v-if="iconsetChanged" class="text-warning font-italic"
                    ><i class="fa fa-exclamation-triangle mr-2"></i>Remember to save your
                    customization below</small
                >
            </transition>
            <div class="w-100">
                <span
                    class="cursor-pointer font-weight-bold text-primary"
                    @click="saveIconset()"
                    v-html="
                        saving === tracker.type
                            ? `<i class='fa fa-spin fa-circle-o-notch mr-2'></i>Saving...`
                            : `<i class='fa fa-save mr-2'></i>Save`
                    "
                >
                </span>
            </div>
        </div>
        <div v-else="" class="pb-2">
            <template v-if="tracker.type === 'duration'">
                <span
                    class="font-weight-bold text-capitalize text-primary cursor-pointer pb-2"
                    @click="$emit('edit-tracker')"
                    ><i class="fa fa-edit mr-2"></i>Modify prompt buttons for optional
                    intensity</span
                >
                <intensity :iconset="getSelectedIconset(tracker) || 0"></intensity>
            </template>
            <template v-else="">
                <span
                    class="font-weight-bold text-capitalize text-primary cursor-pointer pb-2"
                    @click="$emit('edit-tracker')"
                    ><i class="fa fa-edit mr-2"></i>Modify prompt buttons</span
                >
                <prompt :iconset="getSelectedIconset(tracker) || 0"></prompt>
            </template>
        </div>
    </div>
</template>

<script>
import Prompt from "../ui/PromptIcon";
import Intensity from "../ui/IntensityIcon";
export default {
    props: ["editing", "saving", "tracker"],
    name: "CustomizeIconset",
    components: { Prompt, Intensity },
    data() {
        return {
            iconsetChanged: false,
        };
    },
    methods: {
        getSelectedIconset(tracker) {
            return tracker.hasOwnProperty("default_options") &&
                tracker.default_options &&
                tracker.default_options.hasOwnProperty("iconset")
                ? tracker.default_options.iconset
                : null;
        },
        changeIconset(i) {
            this.$emit("select-iconset", i - 1);
            this.iconsetChanged = true;
        },
        saveIconset() {
            this.$emit("save-tracker-customization");
            this.iconsetChanged = false;
        },
    },
};
</script>

<style scoped></style>
